import request from "@/utils/axios_gispai";

// 新建数据或文件夹(新)
export function create_file(params) {
  return request({
    url: "api/GData/create_file",
    method: "post",
    data: params
  });
}

// 获取文件树状列表
export function getMyList(params) {
  return request({
    url: "api/GData/GetTreeFile",
    method: "get",
    params: params
  });
}

// 获取文件树状列表全部数据
export function getMyAllList(params) {
  return request({
    url: "api/GData/GetTreeFileAll",
    method: "get",
    params: params
  });
}

// 获取我的地图 -> 树状列表
export function GetMapDocTree(params) {
  return request({
    url: "api/MapDoc/GetTreeFile",
    method: "get",
    params: params
  });
}


// 获取我的地图 -> 树状列表--过滤已绑过主题地图
export function GetTreeFileCanOpenMap(params) {
  return request({
    url: "api/MapDoc/GetTreeFileCanOpenMap",
    method: "post",
    params: params
  });
}
// 获取我的地图 -> 文件列表
export function GetMapDocList(params) {
  return request({
    url: "api/MapDoc/GetMapDocList",
    method: "get",
    params: params
  });
}

/**
 * 获取文件列表
 * @param {*} Id
 * @param {*} UserId
 */
export function GetFileList(Id, params) {
  return request({
    url: `api/GData/GetFileList/${Id}`,
    method: "get",
    params: params
  });
}
/**
 * 获取文件列表1
 * @auther : hxq
 * @param {*} Id
 * @param {*} UserId
 */
export function GetFileList1(params) {
  return request({
    url: "api/GData/GetFileList",
    method: "get",
    params: params
  });
}

// 删除我的数据
export function Delete_file(params) {
  return request({
    url: "api/GData/Delete_file",
    method: "post",
    data: params
  });
}
//删除我的地图
export function deleteMapDoc(params) {
  return request({
    url: "api/MapDoc/deleteMapDoc",
    method: "get",
    params: params
  });
}

/**
 * 获取最近浏览文件列表
 * @param {*} UserId
 */
export function GetRecentlyFileList(params) {
  return request({
    url: `api/GData/GetRecentlyFileList`,
    method: "get",
    params: params
  });
}

// 获取回收站
export function GetRecycleFileList(params) {
  return request({
    url: "api/GData/GetRecycleFileList",
    method: "get",
    params: params
  });
}

// 还原文件
export function Restore_file(params) {
  return request({
    url: "api/GData/Restore_file",
    method: "get",
    params: params
  });
}

// 分享
export function ShareForWeChat(params) {
  return request({
    url: `api/GData/ShareForWeChat`,
    method: "post",
    data: params
  });
}

/**
 * 搜索文件
 * @param {*} Name  文件名
 */
export function searchGData(params) {
  return request({
    url: `api/GData/searchGData`,
    method: "post",
    data: params
  });
}

/**
 * 获取星标列表
 * @param {*} UserId 用户ID
 * @param {*} isStar 是否星标
 */
export function getStarFiles(params) {
  return request({
    url: `api/GData/getStarFiles`,
    method: "post",
    data: params
  });
}

/**
 * 生成分享链接信息
 * @param {*} params
 */
export function createGDataShareCre(params) {
  return request({
    url: `api/GData/createGDataShareCre`,
    method: "post",
    data: params
  });
}

/**
 * 分享文件
 * @param {*} shareToken
 * @param {*} useid
 */
export function shareGData(params) {
  return request({
    url: `api/GData/shareGData`,
    method: "get",
    params: params
  });
}

/**
 * 获取分享文件列表
 * @param {*} useid  接受者Id
 * @param {*} shareToken 数据Id
 */
export function shareMapDoc(params) {
  return request({
    url: `api/MapDoc/shareMapDoc`,
    method: "get",
    params: params
  });
}

/**
 * 获取分享文件列表--我的数据
 * @param {*} UserId  接受者Id
 * @param {*} GDataId 数据Id
 * @param {*} Filetype 文件类型（1：文件夹，2：shp文件）
 */
export function getShareList(params) {
  return request({
    url: `api/GData/getShareList`,
    method: "post",
    data: params
  });
}
/**
 * 获取分享文件列表--我的地图
 * @param {*} UserId  接受者Id
 * @param {*} GDataId 数据Id
 * @param {*} Filetype 文件类型（1：文件夹，2：shp文件）
 */
export function getMapDocShareList(params) {
  return request({
    url: `api/MapDoc/getShareList`,
    method: "post",
    data: params
  });
}

/**
 * 获取分享文件列表
 * @param {*} UserId  接受者Id
 * @param {*} GDataId 数据Id
 */
export function getSharedUsers(params) {
  return request({
    url: `api/GData/getSharedUsers`,
    method: "post",
    data: params
  });
}

/**
 * 获取分享文件列表
 * @param {*} IsOpen  隐私或共享
 * @param {*} GDataId 数据Id
 * @param {*} sharedUsers 新增成员
 * @param {*} sharedUsersDel 删除成员
 */
export function addSharedUsers(params) {
  return request({
    url: `api/GData/addSharedUsers`,
    method: "post",
    data: params
  });
}

/**
 * 获取分享文件列表
 * @param {*} UserId  接受者Id
 * @param {*} MapDocId 数据Id
 */
export function getSharedUsersMap(params) {
  return request({
    url: `api/MapDoc/getSharedUsers`,
    method: "post",
    data: params
  });
}

/**
 * 获取分享文件列表
 * @param {*} UserId  UserId
 * @param {*} GDataId 数据Id
 * @param {*} IsStar 是否星标
 */
export function changeStar(params) {
  return request({
    url: `api/GData/changeStar`,
    method: "post",
    data: params
  });
}

/**
 * 获取分享文件列表
 * @param {*} UserId  UserId
 * @param {*} GDataId 数据Id
 * @param {*} IsStar 是否星标
 */
export function changeStarForShare(params) {
  return request({
    url: `api/GData/changeStarForShare`,
    method: "post",
    data: params
  });
}

/**
 * 搜索数据商城数据
 * @param {*} UserId  UserId
 * @param {*} Name 名称
 * @param {*} Describe 描述
 * @param {*} Coordinate 坐标系
 * @param {*} Publisher 发布人
 * @param {*} PriceMax 最大价格
 * @param {*} PriceMin 最小价格
 * @param {*} Type 类型 全部，官方，非官方，免费，付费
 * @param {*} PageIndex 当前页数
 * @param {*} PageSize 每页显示数量
 */
export function getInfoAndReqs(params) {
  return request({
    url: `api/GDataStore/getInfoAndReqs`,
    method: "post",
    data: params
  });
}

/**
 * 修改文件名
 * @param {*} params
 */
export function renameGData(params) {
  return request({
    url: "api/GData/renameGData",
    method: "get",
    params: params
  });
}
/**
 * 修改我的地图文件名
 * @param {*} params
 */
export function updateMapDoc(params) {
  return request({
    url: "api/MapDoc/updateMapDoc",
    method: "get",
    params: params
  });
}

// /**
//  * 新建我的地图
//  * @param {*} params
//  */
export function AddProjectData(params) {
  return request({
    url: "api/MapDoc/AddProjectData",
    method: "post",
    data: params
  });
}
/**
 * 新建我的地图或文件
 * @param {*} params
 */
export function AddMapDocData(params) {
  return request({
    url: "api/MapDoc/AddMapDocData",
    method: "post",
    data: params
  });
}
/**
 * 获取二维码
 * @param {*} params
 */
export function GetPayUrl(params) {
  return request({
    url: "api/Payment/GetPayUrl",
    method: "post",
    params: params
  });
}
/**
 * 分享我的地图给成员
 * @param {*} params
 */
export function SharedMapDoc(params) {
  return request({
    url: "api/MapDoc/addSharedUsers",
    method: "post",
    data: params
  });
}
/**
 * 生成我的地图分享连接
 * @param {*} params
 */
export function createMapDocShareCre(params) {
  return request({
    url: "api/MapDoc/createMapDocShareCre",
    method: "post",
    data: params
  });
}

/**
 * 获取地图分享链接
 * @param {*} params
 */
export function getMapDocShareCre(params) {
  return request({
    url: "api/MapDoc/getMapDocShareCre",
    method: "post",
    data: params
  });
}
  // 获取公开地图数据 /
export function getOpenMapDataList (params) {
    return request({
      url: 'api/OpenMapData/GetOpenMapDataList',
      method: 'get',
      params: params
    })
  }

/**
 * 获取数据分享链接
 * @param {*} params
 */
export function getGDataShareCre(params) {
  return request({
    url: "api/GData/getGDataShareCre",
    method: "post",
    data: params
  });
}

/**
 * 获取我参与的地图众包列表
 * @param {*} params
 */
export function getCrowForUser(params) {
  return request({
    url: "api/Crowdsourcing/getCrowForUser",
    method: "post",
    data: params
  });
}
/**
 * 获取我发布的地图众包列表
 * @param {*} params
 */
export function getCrowForPublic(params) {
  return request({
    url: "api/Crowdsourcing/getCrowForPublic",
    method: "post",
    data: params
  });
}

/**
 * 发布众包
 * @param {*} params
 */
export function getCrows(params) {
  return request({
    url: "api/Crowdsourcing/getCrows",
    method: "post",
    data: params
  });
}
/**
 * 发布众包
 * @param {*} params
 */
export function createCrowdsourcing(params) {
  return request({
    url: "api/Crowdsourcing/create",
    method: "post",
    data: params
  });
}
/**
 * 根据众包查看任务
 * @param {*} params
 */
export function getTaskForCrowId(params) {
  return request({
    url: "api/Task/getTaskForCrowId",
    method: "get",
    params: params
  });
}

/**
 * 参与任务（公开）
 * @param {*} params
 */
export function joinTask(params) {
  return request({
    url: "api/Task/joinTask",
    method: "post",
    data: params
  });
}
/**
 * 获取众包详情
 * @param {*} params
 */
export function getCrowById(params) {
  return request({
    url: "api/Crowdsourcing/getCrowById",
    method: "post",
    params: params
  });
}

/**
 * 获取众包详情
 * @param {*} params
 */
export function getCrowByMapDocId(params) {
  return request({
    url: "api/Crowdsourcing/getCrowByMapDocId",
    method: "get",
    params: params
  });
}

/**
 * 上传图片
 * @param {*} params
 */
export function UploadImage(params) {
  return request({
    url: "api/GData/UploadImage",
    method: "post",
    data: params
  });
}
/**
 * 获取关于地图派或者升级VIP
 * @param {*} params
 */
export function getAboutGISPAI(params) {
  return request({
    url: "api/AboutGISPAI/getAboutGISPAI",
    method: "get",
    params: params
  });
}
/**
 * 获取关于地图派或者升级VIP
 * @param {*} params
 */
export function getUsingHelps(params) {
  return request({
    url: "api/UsingHelp/getUsingHelps",
    method: "get",
    params: params
  });
}
/**
 * 移动我的数据文件
 * @param {*} params
 */
export function moveGData(params) {
  return request({
    url: "api/GData/moveGData",
    method: "post",
    params: params
  });
}
/**
 * 移动我的地图文件
 * @param {*} params
 */
export function moveMapDoc(params) {
  return request({
    url: "api/MapDoc/moveMapDoc",
    method: "post",
    params: params
  });
}
/**
 * 我购买的数据
 * @param {*} params
 */
export function getDataStoreInfosBuyed(params) {
  return request({
    url: "api/GDataStore/getDataStoreInfosBuyed",
    method: "get",
    params: params
  });
}

/**
 * 我购买的数据
 * @param {*} params
 */
export function getMyRequire(params) {
  return request({
    url: "api/GDataStore/getMyRequire",
    method: "post",
    params: params
  });
}

/**
 * 上传文件shp
 * @param {*} params
 */
export function UploadShpFile(params) {
  return request({
    url: "api/GData/UploadShpFile",
    method: "post",
    data: params
  });
}
/**
 * 上传文件shp-华为云
 * @param {*} params
 */
// export function uploadByUrl(params) {
//     return request({
//         url: 'api/Aliyun/Aliyun_UploadByUrl',
//         method: 'post',
//         params: params
//     })
// }
export function uploadByUrl(params) {
  return request({
    url: "api/Cloud/Cloud_UploadByUrl",
    method: "post",
    params: params
  });
}
/**
 * 上传文件shp-成功-回调
 * @param {*} params
 */
// export function AliyunDownRar(params) {
//     return request({
//         url: 'api/Aliyun/Aliyun_DownRar',
//         method: 'post',
//         data: params
//     })
// }
export function AliyunDownRar(params) {
  return request({
    url: "api/Cloud/Cloud_DownRar",
    method: "post",
    data: params
  });
}

/**
 * 获取用户通知信息
 * @param {*} UserId 接收通知用户Id
 * @param {*} Type 类型
 * @param {*} PageIndex 页数
 * @param {*} PageSize 每页显示数量
 */
export function searchNotification(params) {
  return request({
    url: "api/Notification/searchNotification",
    method: "post",
    data: params
  });
}

/**
 * 获取用户通知信息
 * @param {*} userId
 */
export function getUnReadNumber(params) {
  return request({
    url: "api/Notification/getUnReadNumber",
    method: "get",
    params: params
  });
}
/**
 * 批量删除我的数据
 */
export function deleteGDataGroup(params) {
  return request({
    url: "api/GData/deleteGDataGroup",
    method: "post",
    data: params
    // params: params
  });
}
/**
 * 批量删除我的地图
 */
export function deleteMapDocGroup(params) {
  return request({
    url: "api/MapDoc/deleteMapDocGroup",
    method: "post",
    data: params
    // params: params
  });
}

/**
 * 删除分享文档（参与者）数据
 */
export function deleteGDataShare(params) {
  return request({
    url: "api/GData/deleteGDataShare",
    method: "get",
    params: params
  });
}

/**
 * 删除分享文档（参与者）地图
 */
export function deleteMapDocShare(params) {
  return request({
    url: "api/MapDoc/deleteMapDocShare",
    method: "get",
    params: params
  });
}

/**
 * 上传文件-上传云对象-华为云
 * @param {*} params
 */
export function GetUploadUrl(params) {
  return request({
    url: "api/GData/GetUploadUrl",
    method: "get",
    params: params
  });
}

/**
 * 获取任务区数据列表
 * @param {*} params
 */
export function GetTaskDataList(params) {
  return request({
    url: "api/GData/GetTaskDataList",
    method: "get",
    params: params
  });
}

/**
 * 设定为任务数据
 * @param {*} params
 */
export function setGDatatoTaskData(params) {
  return request({
    url: "api/GData/setGDatatoTaskData",
    method: "post",
    data: params
  });
}

export function releaseCrow(params) {
  return request({
    url: "api/Crowdsourcing/releaseCrow",
    method: "get",
    params: params
  });
}

export function changeCrow(params) {
  return request({
    url: "api/Crowdsourcing/changeCrow",
    method: "post",
    data: params
  });
}
export function updateCrowInfo(params) {
  return request({
    url: "api/Crowdsourcing/updateCrowInfo",
    method: "post",
    data: params
  });
}
export function addCrowManager(params) {
  return request({
    url: "api/Crowdsourcing/addCrowManager",
    method: "get",
    params: params
  });
}
export function getCrowManager(params) {
  return request({
    url: "api/Crowdsourcing/getCrowManager",
    method: "get",
    params: params
  });
}
export function deleteCrowManager(params) {
  return request({
    url: "api/Crowdsourcing/deleteCrowManager",
    method: "get",
    params: params
  });
}
export function getUserTypeForCrow(params) {
  return request({
    url: "api/Crowdsourcing/getUserTypeForCrow",
    method: "get",
    params: params
  });
}
export function getCaseHelps(params) {
  return request({
    url: "api/CaseHelp/getCaseHelps",
    method: "get",
    params: params
  });
}
export function finishCrow(params) {
  return request({
    url: "api/Crowdsourcing/finishCrow",
    method: "get",
    params: params
  });
}

//获取地图的关联信息
export function getAllBindForMapDoc(params) {
  return request({
    url: "api/MapDoc/getAllBindForMapDoc",
    method: "get",
    params: params
  });
}

//设置图层显隐
export function updateLayerVisible(params) {
  return request({
    url: "api/MapDoc/UpdateLayerIsConcealed",
    method: "post",
    data: params
  });
}

//设置图形数据显隐
export function SettingShowMaterial(params) {
  return request({
    url: "api/MapDoc/SettingShowMaterial",
    method: "post",
    data: params
  });
}

//查询众包中的影像图层
export function getBaseLayer(params) {
  return request({
    url: "api/Crowdsourcing/getLayerByCrow",
    method: "get",
    params: params
  });
}
export function getAllMapParameter(params) {
  return request({
    url: "api/MapParameter/getAllMapParameter",
    method: "get",
    params: params
  });
}
export function addMapParameter(params) {
  return request({
    url: "api/MapParameter/addMapParameter",
    method: "post",
    data: params
  });
}
export function updateMapParameter(params) {
  return request({
    url: "api/MapParameter/updateMapParameter",
    method: "post",
    data: params
  });
}
export function deleteMapParameter(params) {
  return request({
    url: "api/MapParameter/deleteMapParameter",
    method: "get",
    params: params
  });
}

export function getAllBaseMapParameter(params) {
  return request({
    url: "api/BaseMapParameter/getAllBaseMapParameter",
    method: "get",
    params: params
  });
}
export function updateBaseLayerId(params) {
  return request({
    url: "api/MapDoc/UpdateSpatialID",
    method: "get",
    params: params
  });
}

export function getAllBaseMapParameterName(params) {
  return request({
    url: "api/BaseMapParameter/getAllBaseMapParameterName",
    method: "get",
    params: params
  });
}
export function addBaseMapParameter(params) {
  return request({
    url: "api/BaseMapParameter/addBaseMapParameter",
    method: "post",
    data: params
  });
}
export function updateBaseMapParameter(params) {
  return request({
    url: "api/BaseMapParameter/updateBaseMapParameter",
    method: "post",
    data: params
  });
}
export function deleteBaseMapParameter(params) {
  return request({
    url: "api/BaseMapParameter/deleteBaseMapParameter",
    method: "get",
    params: params
  });
}

export function deleteCrow(params) {
  return request({
    url: "api/Crowdsourcing/deleteCrow",
    method: "get",
    params: params
  });
}
export function UploadShpFile1(params) {
  return request({
    url: "api/CGData/UploadShpFile",
    method: "post",
    data: params
  });
}
//添加xy数据
export function UploadTextorExcel(params) {
  return request({
    url: "api/GeoDataFeature/UploadTextorExcel",
    method: "post",
    data: params
  });
}
//更新数据描述
export function UpdateDescribeForGdata(params) {
  return request({
    url: "api/GData/UpdateDescribeForGdata",
    method: "get",
    params: params
  });
}
//获取官方数据
export function GetOfficialFileList(params) {
  return request({
    url: "api/GData/GetOfficialFileList",
    method: "get",
    params: params
  });
}
//导出shp
export function exportShp(params) {
  return request({
    url: "api/GData/exportSHP",
    method: "get",
    params: params
  });
}
//上传cad
export function UploadCAD(params) {
  return request({
    url: "api/GeoDataFeature/UploadCAD",
    method: "post",
    data: params
  });
}
//导出成cad
export function exportCad(params) {
  return request({
    url: "api/GeoDataFeature/DownCADs_dxfs",
    method: "get",
    params: params
  });
}
// 地图底图显隐
export function updateBaseLayerVisible(params) {
  return request({
    url: "api/MapDoc/updateOpenBaseMapDoc",
    method: "get",
    params: params
  });
}
// 获取api地址
export function getGISApi(params) {
  return request({
    url: "api/MapParameter/getInitMapParameters",
    method: "get",
    params: params
  });
}
// 更新地图描述
export function updateMapDocSynopsis(params) {
  return request({
    url: "/api/MapDoc/UpdateMapDocSynopsis",
    method: "post",
    data: params
  });
}

export function getTry_NewMethod(params, token) {
  return request({
    url: "/api/GData/GetTry_NewMethod",
    method: "get",
    params: params,
    cancelToken: token
  });
}
// 获取坐标系列表
export function get_coorList(params, token) {
  return request({
    url: "/api/GData/GetCustomCoordinate",
    method: "get",
    params: params
    // cancelToken: token
  });
}
// 添加自定义坐标系
export function add_customCoor(params, token) {
  return request({
    url: "/api/GData/AddCustomCoordinate",
    method: "post",
    data: params
    // cancelToken: token
  });
}
// 删除自定义坐标系
export function del_customCoor(params, token) {
  return request({
    url: "/api/GData/DeleteCustomCoordinate",
    method: "get",
    params: params
    // cancelToken: token
  });
}
// 修改自定义坐标系
export function edit_customCoor(params, token) {
  return request({
    url: "/api/GData/UpdateCustomCoordinate",
    method: "post",
    data: params
    // cancelToken: token
  });
}
// bmapId 列表
export function getBmpIdParameter(params, token) {
  return request({
    url: "/api/BaseMapParameter/getAllBaseMapParameter",
    method: "get",
    params: params
    // cancelToken: token
  });
}
// 获取公开数据
export function getOpenGDataList(params, token) {
  return request({
    url: "/api/OpenGData/GetOpenGDataList",
    method: "get",
    params: params
    // cancelToken: token
  });
}
// 添加公开数据
export function addOpenGData(params, token) {
  return request({
    url: "/api/OpenGData/AddOpenGData",
    method: "get",
    params: params
    // cancelToken: token
  });
}
// 删除公开数据
export function deleteOpenGData(params, token) {
  return request({
    url: "/api/OpenGData/DeleteOpenGData",
    method: "get",
    params: params
    // cancelToken: token
  });
}

// 修改公开数据文件名
export function updateOpenGDataFolderName(params, token) {
  return request({
    url: "/api/OpenGData/UpdateOpenGDataFolderName",
    method: "get",
    params: params
    // cancelToken: token
  });
}
// 设置公开数据权限
export function updataOpenGDataPower(params, token) {
  return request({
    url: "/api/OpenGData/UpdataOpenGDataPower",
    method: "get",
    params: params
    // cancelToken: token
  });
}
// 设置公开数据父文件
export function updateOpenGDataParent(params, token) {
  return request({
    url: "/api/OpenGData/UpdateOpenGDataParent",
    method: "get",
    params: params
    // cancelToken: token
  });
}
//获取地图token///api/MapDoc/GetMapDocToken
export function GetMapDocToken(params) {
  return request({
    url: "/api/MapDoc/GetMapDocToken",
    method: "get",
    params: params

  });
}
// 获取素材列表
export function GetMaterialAll(params) {
  return request({
    url: 'api/Material/GetMaterialAll',
    method: 'post',
    data: params
  })
}
// 修改素材
export function UpdateMaterial(params) {
  return request({
    url: 'api/Material/UpdateMaterial',
    method: 'post',
    data: params
  })
}
// 添加素材
export function AddMaterial(params) {
  return request({
    url: 'api/Material/AddMaterial',
    method: 'post',
    data: params
  })
}
// 删除素材
export function DeleteMaterial(params) {
  return request({
    url: 'api/Material/DeleteMaterial',
    method: 'post',
    data: params
  })
}
// 属性修改坐标系
export function UpdateGDataCoordinate(params) {
  return request({
    url: '/api/GData/UpdateGDataCoordinate',
    method: 'post',
    data: params
  })
}

export function GetDownloadableList(params) {
  return request({
    url: "/api/DownloadGDB/GetDownloadableList",
    method: "get",
    params: params

  });
}

export function CreateDownloadFileTask(params) {
  return request({
    url: '/api/DownloadGDB/CreateDownloadFileTask',
    method: 'post',
    data: params
  })
}

export function GetDownloadOBSUrl(params) {
  return request({
    url: '/api/DownloadGDB/GetDownloadOBSUrl',
    method: 'post',
    data: params
  })
}

export function DeleteDownloadFile(params) {
  return request({
    url: '/api/DownloadGDB/DeleteDownloadFile',
    method: 'post',
    data: params
  })
}

export function createDownloadFileTaskPart (params) {
  return request({
    url: 'api/DownloadGDB/CreateDownloadFileTaskPart',
    method: 'post',
    data: params
  })
}

export function UpdateMapMaterial (params) {
  return request({
    url: 'api/Material/UpdateMapMaterial',
    method: 'post',
    data: params
  })
}

export function GetMapMaterial (params) {
  return request({
    url: 'api/Material/GetMapMaterial',
    method: 'post',
    data: params
  })
}

export function SaveBigImage (params) {
  return request({
    url: 'api/EMap/DownEmapPic',
    method: 'post',
    data: params
  })
}

export function SaveSmallImage (params) {
  return request({
    url: 'api/EMap/CreateEmap',
    method: 'post',
    data: params
  })
}

export function UpdateEmap (params) {
  return request({
    url: 'api/EMap/UpdateEmap',
    method: 'post',
    data: params
  })
}

export function GetCommonlyMaterialList (params) {
  return request({
    url: 'api/Material/GetCommonlyMaterialList',
    method: 'get',
    params: params
  })
}

// 生成标注
export function CreateGeoMark (params) {
  return request({
    url: 'api/Material/CreateGeoMark',
    method: 'post',
    data: params
  })
}

export function UpdateCommonlyMaterial (params) {
  return request({
    url: 'api/Material​/UpdateCommonlyMaterial',
    method: 'post',
    data: params
  })
}

export function CreateCommonlyMaterial (params) {
  return request({
    url: 'api/Material/CreateCommonlyMaterial',
    method: 'post',
    data: params
  })
}

export function DeleteCommonlyMaterial (params) {
  return request({
    url: 'api/Material/DeleteCommonlyMaterial',
    method: 'post',
    data: params
  })
}

//导出大图///api/EMap/DownEmapPic
export function exportImg(params) {
  return request({
    url: 'api/EMap/DownEmapPic',
    method: 'post',
    data: params
  })
}

//导出视频///api/DownloadGDB/DownMapDocVideo
export function exportVideo(params) {
  return request({
    url: 'api/DownloadGDB/DownMapDocVideo',
    method: 'post',
    data: params
  })
}
// 获取素材我的图片列表
export function GetPrivaterMaterialList (params) {
  return request({
    url: 'api/Material/GetPrivaterMaterialList',
    method: 'get',
    params: params
  })
}

// 获取素材我的图片类型列表
export function GetPrivateMaterialTypes (params) {
  return request({
    url: 'api/Material/GetPrivateMaterialTypes',
    method: 'get',
    params: params
  })
}

// 删除我的图片
export function DeletePrivaterMaterial (params) {
  return request({
    url: 'api/Material/DeletePrivaterMaterial',
    method: 'post',
    data: params
  })
}

// 删除我的图片类型
export function DeletePrivateForType (params) {
  return request({
    url: 'api/Material/DeletePrivateForType',
    method: 'post',
    data: params
  })
}

// 一键生成地图文档
export function CreateMapOneKey (params) {
  return request({
    url: 'api/MapDoc/CreateMapOneKey',
    method: 'post',
    data: params
  })
}

// 获取自己的所有地图和图层名
export function GetAllMapDocAndLayer () {
  return request({
    url: 'api/MapDoc/GetAllMapDocAndLayer',
    method: 'get'
  })
}

// 获取自己数据的树状图根据数据类型
export function GetMyTreeFileByGDataType (GDataType) {
  return request({
    url: `api/GData/GetMyTreeFileByGDataType?GDataType=${GDataType}`,
    method: 'get'
  })
}
